import React from 'react';
import EntityInfoWidget from '@components/widgets/entity-info/EntityInfoWidget';
import { IEntityInfoView } from '@components/widgets/entity-info/EntityInfoFields';
import { EnhancedDisplayType } from '@components/widgets/dynamic-display/EnhancedDisplay';
import { MAIN_THEME } from '@styles';

interface ILeftPanel {
  data: Record<string, string>;
}

const LeftPanel: React.FC<ILeftPanel> = ({ data }) => {
  const entityView: IEntityInfoView = {
    iconUrl: '',
    socialMedia: {
      facebook: '',
      twitter: '',
      linkedIn: '',
    },
    sections: [
      {
        title: '',
        name: 'BasicInformation',
        properties: {
          treatyId: {
            name: 'treatyId',
            title: 'Treaty ID',
            value: data?.production_Treaties_TreatyID,
            multiline: false,
          },
          createdBy: {
            name: 'createdBy',
            title: 'Created By',
            value: data?.production_Treaties_CreatedByName,
            multiline: false,
          },
          createdOn: {
            name: 'createdOn',
            title: 'Created On',
            value: data?.production_Treaties_createdOn,
            multiline: false,
            type: EnhancedDisplayType.DateTime,
          },
          modifiedBy: {
            name: 'modifiedBy',
            title: 'Modified By',
            value: data?.production_Treaties_UpdatedByName,
            multiline: false,
          },
          modifiedOn: {
            name: 'modifiedOn',
            title: 'Modified On',
            value: data?.production_Treaties_modifiedOn,
            multiline: false,
            type: EnhancedDisplayType.DateTime,
          },
        },
      },
    ],
  };

  return (
    <EntityInfoWidget
      title={data?.production_Treaties_TreatyName}
      view={entityView}
      supportsClassification={true}
      background={MAIN_THEME.color.red}
      classification={{ classifications: {}, value: '' }}
      progress={100}
      supportsProgressBar={true}
    />
  );
};

export default LeftPanel;
